import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultesCsvComponent } from '@app/components/consultes-csv/consultes-csv.component';
import { FormsModule } from '@angular/forms';


@NgModule({
    imports:      [
        CommonModule,
        FormsModule,
    ],
    declarations: [
        ConsultesCsvComponent
    ],
    exports: [
        ConsultesCsvComponent
    ]
})
export class ConsultesCsvModule { }
